var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-time-select',_vm._b({staticStyle:{"max-width":"110px"},attrs:{"clearable":true,"picker-options":{
      start: '00:00',
      end: '24:00'
    },"size":"small"},on:{"input":_vm.handleTimeChange},model:{value:(_vm.newValue),callback:function ($$v) {_vm.newValue=$$v},expression:"newValue"}},'el-time-select',_vm.attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }